// extracted by mini-css-extract-plugin
export default {"container":"DocsPage_container__oAur1"};